import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(() => ({
    root: {
        marginLeft: 'auto',
    },
}));

const MTableSearch = ({ searchValue, onSearchSubmit = () => {} }) => {
    const classes = useStyles();
    const [value, setValue] = useState(searchValue);

    return (
        <TextField
            className={classes.root}
            value={value}
            onChange={event => setValue(event.target.value)}
            placeholder="Search"
            color="inherit"
            onKeyPress={ev => {
                if (ev.key === 'Enter') {
                    onSearchSubmit(value);
                    ev.preventDefault();
                }
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon color="inherit" fontSize="small" />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            disabled={!value}
                            onClick={() => onSearchSubmit('')}
                        >
                            <CloseIcon color="inherit" fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export { MTableSearch };
